import React from 'react';
import { observer } from 'mobx-react';
import { ExtrasShimmer } from './ExtrasShimmer';
import { AncillaryGroup } from './ancillary';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';

export const ExtrasMain = observer(() => {
	const { parkingProductsQuoteStore } = useNewBookingStore();

	if (!parkingProductsQuoteStore.hasFinishedLoadingAncillaries) {
		return <ExtrasShimmer />;
	}

	return (
		<>
			{parkingProductsQuoteStore.ancillaryGroups.map(
				(ancillaryGroup, ancillaryGroupIndex) => (
					<AncillaryGroup
						key={ancillaryGroup.id}
						ancillaryGroup={ancillaryGroup}
						nestedInputLevel={{
							ancillaryGroupIndex,
						}}
					/>
				),
			)}
		</>
	);
});
